import React, { useState, useRef } from 'react';
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import HeaderPage from '../components/HeaderPage';
import NavBar from '../components/NavBar';

const ringSizeData = [
  { indian: 1, circumference: 41, diameter: 13.05 },
  { indian: 2, circumference: 42, diameter: 13.37 },
  { indian: 3, circumference: 43, diameter: 13.69 },
  { indian: 4, circumference: 44, diameter: 14.01 },
  { indian: 5, circumference: 45, diameter: 14.33 },
  { indian: 6, circumference: 46, diameter: 14.65 },
  { indian: 7, circumference: 47, diameter: 14.97 },
  { indian: 8, circumference: 48, diameter: 15.29 },
  { indian: 9, circumference: 49, diameter: 15.61 },
  { indian: 10, circumference: 50, diameter: 15.92 },
  { indian: 11, circumference: 51, diameter: 16.24 },
  { indian: 12, circumference: 52, diameter: 16.56 },
  { indian: 13, circumference: 53, diameter: 16.88 },
  { indian: 14, circumference: 54, diameter: 17.20 },
  { indian: 15, circumference: 55, diameter: 17.52 },
  { indian: 16, circumference: 56, diameter: 17.83 },
  { indian: 17, circumference: 57, diameter: 18.14 },
  { indian: 18, circumference: 58, diameter: 18.47 },
  { indian: 19, circumference: 59, diameter: 18.79 },
  { indian: 20, circumference: 60, diameter: 19.11 },
  { indian: 21, circumference: 61, diameter: 19.43 },
  { indian: 22, circumference: 62, diameter: 19.75 },
  { indian: 23, circumference: 63, diameter: 20.07 },
  { indian: 24, circumference: 64, diameter: 20.39 },
  { indian: 25, circumference: 65, diameter: 20.70 },
  { indian: 26, circumference: 66, diameter: 21.01 },
  { indian: 27, circumference: 67, diameter: 21.33 },
  { indian: 28, circumference: 68, diameter: 21.64 },
  { indian: 29, circumference: 69, diameter: 21.96 },
  { indian: 30, circumference: 70, diameter: 22.28 },
];

// Slider range: index 0–29, maps to ringSizeData
const MIN_IDX = 0;
const MAX_IDX = ringSizeData.length - 1;

// Base px diameter for Indian size 1 at 96 PPI. We scale visually.
// We'll render the circle at the actual mm diameter using a px/mm ratio.
// Typical screen: 1 CSS px ≈ 0.2646 mm  →  1 mm ≈ 3.78 px (96dpi)
const MM_TO_PX = 3.78;

const RingSizePage = () => {
  const navigate = useNavigate();
  const [sizeIdx, setSizeIdx] = useState(18); // default: Indian 19
  const tableRef = useRef(null);

  const current = ringSizeData[sizeIdx];
  const circlePx = current.diameter * MM_TO_PX;

  const handleSliderChange = (e) => {
    const idx = Number(e.target.value);
    setSizeIdx(idx);
    // Scroll table to highlight row
    setTimeout(() => {
      const row = document.getElementById(`ring-row-${idx}`);
      if (row) row.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }, 50);
  };

  return (
    <>
      <Helmet>
        <title>Ring Size Checker</title>

      </Helmet>

      <HeaderPage title="Ring Size Checker" />

      <main className="page-content mypadding ring-size-page overflow-auto pb-4">

        {/* Checker card */}
        <div className="ring-checker-card">
          <p className="ring-instruction">
            Place your ring on the circle and adjust the size using the slider.
            The circle should overlap with the inner edge of your ring to get a
            near accurate measurement.
          </p>

          {/* Circle preview */}
          <div className="ring-canvas">
            <div
              className="ring-circle"
              style={{ width: circlePx, height: circlePx }}
            />
            <div className="ring-size-badge">Size {current.indian}</div>
          </div>

          {/* Slider */}
          <div className="ring-slider-wrap">
            <div className="ring-slider-labels">
              <span>Size 1</span>
              <span>Size 30</span>
            </div>
            <input
              type="range"
              className="ring-slider"
              min={MIN_IDX}
              max={MAX_IDX}
              value={sizeIdx}
              onChange={handleSliderChange}
              style={{ '--pct': (sizeIdx / MAX_IDX) * 100 }}
            />
          </div>
        </div>

        {/* Info pills */}
        <div className="ring-info-pills">
          <div className="ring-pill">
            <div className="ring-pill-label">Indian Size</div>
            <div className="ring-pill-value">{current.indian}</div>
          </div>
          <div className="ring-pill">
            <div className="ring-pill-label">Circumference</div>
            <div className="ring-pill-value">{current.circumference}</div>
            <div className="ring-pill-unit">mm</div>
          </div>
          <div className="ring-pill">
            <div className="ring-pill-label">Diameter</div>
            <div className="ring-pill-value">{current.diameter.toFixed(2)}</div>
            <div className="ring-pill-unit">mm</div>
          </div>
        </div>

        {/* Reference table */}
        <div className="ring-table-section">
          <div className="ring-table-header">
            <span>Indian Size</span>
            <span>Circumference (mm)</span>
            <span>Diameter (mm)</span>
          </div>
          <div className="ring-table-body" ref={tableRef}>
            {ringSizeData.map((row, idx) => (
              <div
                key={row.indian}
                id={`ring-row-${idx}`}
                className={`ring-table-row${idx === sizeIdx ? ' active' : ''}`}
                onClick={() => setSizeIdx(idx)}
                style={{ cursor: 'pointer' }}
              >
                <span>{row.indian}</span>
                <span>{row.circumference}</span>
                <span>{row.diameter.toFixed(2)}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="ring-bottom-pad" />
      </main>
    </>
  );
};

export default RingSizePage;